module.exports = __webpack_public_path__ + "img/5.caf5bd75.webp";